import { store, getContext } from '@wordpress/interactivity'

store('swd', {
  actions: {
    handleChange: event => {
      const selectElement = event.target
      if (selectElement) {
        const optionValue = selectElement.value
        if (optionValue) {
          window.location.href = `${window.location.origin}/${optionValue}`
        }
      }
    }
  }
})
